import { ActionPayloadValidationError, optionalMinorAmountField } from "../replay/validation/ReplayPayloadValidation";

function requireNonEmptyString(value: unknown, fieldPath: string): string {
  if (typeof value !== "string" || value.trim().length === 0) {
    const dot = fieldPath.indexOf(".");
    throw new ActionPayloadValidationError(fieldPath.slice(0, dot), fieldPath.slice(dot + 1), "Must be a non-empty string.");
  }
  return value;
}

export function validateSpinBoundaryStartPayloadOrThrow(payload: Record<string, unknown>): {
  spinBoundaryIdentifier: string;
  spinModeIdentifier?: string;
} {
  const spinBoundaryIdentifier = requireNonEmptyString(
    payload.spinBoundaryIdentifier,
    'spin_boundary_start.spinBoundaryIdentifier'
  );

  const spinModeIdentifier =
    payload.spinModeIdentifier == null ? undefined : requireNonEmptyString(
      payload.spinModeIdentifier,
      'spin_boundary_start.spinModeIdentifier'
    );

  return { spinBoundaryIdentifier, spinModeIdentifier };
}

export function validateSpinBoundaryEndPayloadOrThrow(payload: Record<string, unknown>): {
  spinBoundaryIdentifier: string;
  spinWinAmount?: string;
} {
  const spinBoundaryIdentifier = requireNonEmptyString(
    payload.spinBoundaryIdentifier,
    'spin_boundary_end.spinBoundaryIdentifier'
  );

  // Whole minor units when present (2026-09-26): until then any text passed, and the win meter
  // silently showed nothing for a malformed amount.
  const spinWinAmount = optionalMinorAmountField("spin_boundary_end", payload, "spinWinAmount");

  return { spinBoundaryIdentifier, spinWinAmount };
}